<template>
    <div class="w-100" style="height: 48px;" v-if="isMobile"></div>
    <div class="nav-header">
      <div class="nav-header__back" v-show="isShowBackButton" @click="goBack()">
        <!-- <img src="../../../static/images/logo_small.png"> -->
        <MainLogo class="mobile-logo"></MainLogo>
        <!-- <svg width="72" height="46" viewBox="0 0 72 46" class="home-nav__icon" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M36.2004 27.2797L34.345 28.7374L29.0013 26.3655L28.7786 22.511L31.6979 20.9544L36.2252 23.1287V12.8502L32.5143 13.5174L30.1393 11.3678L31.2525 7.68629L36.2252 6.54973V5.31433L30.9804 6.52502C30.4361 6.35207 29.9661 6.20382 29.595 6.08028C31.4999 5.01784 33.7017 4.40014 36.052 4.40014C36.1015 4.40014 36.1757 4.40014 36.2252 4.40014V3.18945C36.1757 3.18945 36.1015 3.18945 36.052 3.18945C28.1106 3.18945 21.6289 9.63822 21.6289 17.6189C21.6289 25.896 28.7044 32.3695 36.2499 32.0483L36.2004 27.2797ZM23.7318 19.1013L23.0391 20.1144C22.8906 19.299 22.7917 18.4837 22.7917 17.6436C22.7917 15.7658 23.1875 13.9621 23.9049 12.3314L24.4492 13.6656L23.7318 19.1013ZM24.944 19.0766L25.6614 13.6656L29.2734 12.282L31.6484 14.4316L30.8815 20.0402L28.2343 21.4486L24.944 19.0766ZM27.1953 27.4526H28.457L33.8749 29.8493L34.6666 30.7635C31.7968 30.467 29.2239 29.2563 27.1953 27.4526Z" fill="#01C3F7"/>
                      <path d="M39.3589 3.30945C40.2248 12.754 40.2248 22.0506 39.3589 31.4952C38.7651 31.5691 38.4434 31.6185 37.8249 31.6185C37.9734 25.0344 38.0476 18.4503 37.9981 11.8663C37.7012 11.8663 37.5528 11.8663 37.2559 11.8909C37.2559 9.86886 37.2559 8.85782 37.2559 6.83575C38.0476 5.33152 38.4187 4.6164 38.9877 3.26013C39.1362 3.28479 39.2104 3.30945 39.3589 3.30945Z" fill="#01C3F7"/>
                      <path d="M43.5894 4.61638C44.1585 6.12061 44.4306 6.93437 44.8512 8.58655C43.9111 8.38927 43.4162 8.29064 42.4266 8.16734C42.4018 8.16734 42.3771 8.192 42.3276 8.24132C42.3029 8.29064 42.2781 8.36461 42.2781 8.48791C42.2781 8.61121 42.2534 8.75916 42.2781 8.90712C42.2781 9.07974 42.3029 9.25235 42.3276 9.49895C42.5255 11.0278 42.5998 11.7923 42.6987 13.3705C43.6142 13.3951 44.0595 13.4198 44.9502 13.4691C45.0244 13.4691 45.0739 13.5184 45.1481 13.5924C45.2223 13.6664 45.2966 13.7897 45.3708 13.9376C45.445 14.0856 45.5192 14.2829 45.6182 14.4801C45.6924 14.6774 45.7666 14.924 45.8409 15.1706C45.8904 15.3679 45.9646 15.6145 46.0141 15.8611C46.0635 16.1077 46.113 16.3789 46.1378 16.6255C46.1625 16.8968 46.212 17.1927 46.212 17.4639C46.2367 17.7352 46.2367 18.0311 46.212 18.3024C46.1873 20.7436 45.8161 23.3822 45.1976 25.7495C45.1234 25.9961 45.0739 26.2674 44.9749 26.4893C44.9007 26.7359 44.8265 26.9825 44.7275 27.2044C44.6533 27.4263 44.5543 27.6729 44.4554 27.8949C44.3564 28.1168 44.2574 28.3634 44.1585 28.5607C44.0595 28.8073 43.9358 29.0045 43.8368 29.2265C43.7379 29.4238 43.6389 29.5964 43.5399 29.7443C43.4162 29.9663 43.3173 30.1389 43.2183 30.2868C43.1193 30.4101 43.0451 30.5088 42.9956 30.5334C42.1297 30.9033 41.6596 31.0513 40.7194 31.2979C40.6699 31.3225 40.6205 31.2732 40.571 31.1992C40.5215 31.1253 40.472 31.002 40.4473 30.8293C40.4225 30.6814 40.3978 30.5334 40.373 30.3608C40.3483 30.1882 40.3483 29.9909 40.3236 29.769C40.3236 29.5471 40.2988 29.3005 40.2988 29.0539C40.2988 28.7826 40.2988 28.5114 40.2988 28.1908C40.2988 27.8949 40.3236 27.5743 40.3236 27.2291C40.3483 26.8838 40.3483 26.5386 40.3978 26.1934C40.8679 20.4477 40.8926 14.6774 40.4225 8.95644C40.3978 8.61121 40.3731 8.26598 40.3483 7.92074C40.3236 7.57551 40.3236 7.23028 40.3236 6.90971C40.3236 6.58914 40.3236 6.26856 40.3236 5.94799C40.3236 5.65208 40.3236 5.35617 40.3483 5.08491C40.3483 4.83832 40.3731 4.61638 40.3978 4.41911C40.4225 4.22183 40.4225 4.02456 40.472 3.90126C40.4968 3.80262 40.5215 3.72864 40.5462 3.67932C40.571 3.63001 40.5957 3.60535 40.6452 3.60535C41.8575 3.8766 42.4513 4.07388 43.5894 4.61638ZM44.0842 17.9571C43.6636 17.9571 43.441 17.9571 42.9956 17.9571C42.9709 17.9571 42.9461 18.0064 42.9214 18.0804C42.8967 18.1544 42.8719 18.253 42.8472 18.3517C42.8224 18.4503 42.8224 18.5736 42.7977 18.7216C42.773 18.8449 42.773 18.9928 42.773 19.1161C42.6987 21.8287 42.575 23.1603 42.2534 25.7495C42.2286 25.8728 42.2286 25.9961 42.2286 26.1194C42.2286 26.2427 42.2286 26.366 42.2534 26.44C42.2534 26.5386 42.2781 26.6126 42.3029 26.6619C42.3276 26.7112 42.3524 26.7359 42.3771 26.7359C42.7235 26.6866 42.8967 26.6619 43.2183 26.6126C43.243 26.6126 43.2678 26.5633 43.3173 26.5139C43.3667 26.44 43.3915 26.366 43.441 26.2674C43.4657 26.1934 43.5152 26.0947 43.5399 25.9714C43.5647 25.8481 43.6142 25.7248 43.6142 25.6015C44.0595 23.037 44.2079 21.7054 44.3069 18.9682C44.3069 18.8449 44.3069 18.7216 44.3069 18.5983C44.3069 18.475 44.2822 18.3763 44.2574 18.2777C44.2327 18.2037 44.2079 18.1297 44.1832 18.0558C44.1337 17.9818 44.109 17.9571 44.0842 17.9571Z" fill="#01C3F7"/>
                      <path d="M46.9289 6.83571C46.9783 6.86037 47.0278 6.93435 47.1268 7.00833C47.201 7.08231 47.3247 7.2056 47.4484 7.35356C47.5474 7.4522 47.6464 7.57549 47.7701 7.69879C47.8938 7.82209 48.0175 7.97004 48.1659 8.118C48.2896 8.26596 48.4133 8.41391 48.5618 8.58653C48.6855 8.73449 48.8339 8.9071 48.9577 9.07972C49.1061 9.27699 49.2545 9.47427 49.3783 9.67154C49.5267 9.86882 49.6504 10.0908 49.7741 10.3127C50.4916 11.5457 50.7638 12.2115 51.1596 13.5924C51.2091 13.765 51.2586 13.9623 51.2833 14.1596C51.3328 14.3568 51.3576 14.5541 51.3576 14.7267C51.3823 14.8993 51.3823 15.072 51.3823 15.2446C51.3823 15.4172 51.3823 15.5898 51.3576 15.7378C51.3576 15.8857 51.3328 16.0337 51.3081 16.157C51.2833 16.2803 51.2586 16.4036 51.2091 16.5022C51.1844 16.6008 51.1596 16.6748 51.1101 16.7241C51.0854 16.7981 51.0359 16.8474 51.0112 16.8968C51.0359 16.9461 51.0854 16.9954 51.1101 17.0447C51.1349 17.094 51.1844 17.168 51.2091 17.2173C51.2339 17.2913 51.2833 17.3899 51.3081 17.4886C51.3328 17.5872 51.3576 17.7105 51.3823 17.8338C51.407 17.9818 51.4318 18.1544 51.4565 18.3517C51.4813 18.5489 51.4813 18.7462 51.4813 18.9681C51.4813 19.1901 51.4565 19.3874 51.4318 19.6093C51.407 19.8312 51.3823 20.0285 51.3328 20.2751C50.9617 22.0506 50.6401 22.889 49.7989 24.3932C49.6504 24.6398 49.502 24.8864 49.3535 25.1083C49.2051 25.3303 49.0319 25.5522 48.8834 25.7741C48.735 25.9714 48.5865 26.144 48.4381 26.3166C48.2896 26.4893 48.1412 26.6619 48.0175 26.8098C47.8938 26.9578 47.7701 27.0811 47.6711 27.2044C47.5721 27.3277 47.4732 27.4263 47.3742 27.525C47.2505 27.6483 47.1515 27.7469 47.0773 27.8209C47.0031 27.8948 46.9536 27.9442 46.9041 27.9688C46.1371 28.6593 45.7165 28.9799 44.8259 29.5224C44.7764 29.547 44.7516 29.547 44.7516 29.4977C44.7516 29.4484 44.7516 29.3744 44.7516 29.3004C44.7764 29.2265 44.8011 29.1278 44.8259 29.0045C44.8506 28.8812 44.8753 28.7579 44.9248 28.6346C44.9743 28.462 45.0238 28.2647 45.0733 28.0675C45.1228 27.8702 45.1722 27.6483 45.2465 27.451C45.3207 27.229 45.3702 26.9825 45.4444 26.7359C45.5186 26.4893 45.5681 26.2427 45.6423 25.9961C46.2114 24.048 46.4093 23.0369 46.6567 20.9409C46.6815 20.6203 46.7309 20.2998 46.7804 20.0038C46.8299 19.6833 46.8794 19.412 46.9289 19.1161C46.9783 18.8942 47.0031 18.6722 47.0526 18.475C47.1021 18.2777 47.1268 18.0804 47.1763 17.9078C47.2258 17.7598 47.2505 17.6119 47.3 17.4639C47.3495 17.316 47.399 17.2173 47.4237 17.1187C47.5227 16.9214 47.6216 16.7981 47.7206 16.7488C47.6464 16.6995 47.5969 16.6255 47.5227 16.5269C47.4732 16.4282 47.399 16.3296 47.3495 16.2309C47.3 16.1323 47.2505 16.009 47.201 15.8857C47.1515 15.7624 47.1021 15.6145 47.0526 15.4665C46.9536 15.1213 46.8546 14.7267 46.7557 14.3075C46.6815 13.8636 46.5825 13.3705 46.5083 12.8526C46.2609 11.2497 46.0877 10.4606 45.6671 8.95642C45.5928 8.68517 45.5186 8.41391 45.4444 8.14266C45.3702 7.87141 45.2959 7.64947 45.2465 7.42754C45.1722 7.18094 45.098 6.93435 45.0485 6.73707C44.999 6.5398 44.9496 6.34252 44.9001 6.16991C44.8506 6.02195 44.8259 5.87399 44.7764 5.72604C44.7516 5.57808 44.7269 5.47944 44.7021 5.40547C44.6774 5.33149 44.6774 5.25751 44.7021 5.23285C44.7021 5.20819 44.7269 5.20819 44.7764 5.23285C45.7165 5.82468 46.1371 6.14525 46.9289 6.83571ZM47.3742 9.27699C47.3495 9.27699 47.3247 9.30165 47.3247 9.37563C47.3247 9.44961 47.3495 9.54825 47.3742 9.67154C47.399 9.79484 47.4484 9.9428 47.4732 10.0908C47.5227 10.2387 47.5721 10.4113 47.6216 10.5593C47.968 11.669 48.1164 12.2361 48.3144 13.4198C48.3391 13.6171 48.3886 13.8143 48.4133 13.9623C48.4381 14.1102 48.4876 14.2582 48.5123 14.3568C48.5371 14.5048 48.5865 14.6034 48.636 14.6774C48.6855 14.7514 48.7102 14.776 48.7597 14.8007C49.1061 14.8254 49.2793 14.85 49.6257 14.8747C49.6504 14.8747 49.6752 14.85 49.6999 14.8007C49.7246 14.7514 49.7246 14.6527 49.7246 14.5541C49.7246 14.4555 49.7246 14.3075 49.6999 14.1596C49.6752 14.0116 49.6504 13.839 49.6257 13.6417C49.3783 12.5074 49.2298 11.9402 48.8092 10.8799C48.7597 10.7566 48.7102 10.6333 48.636 10.4853C48.5618 10.3373 48.5123 10.2141 48.4381 10.0908C48.3639 9.96746 48.3144 9.84416 48.2402 9.74552C48.1659 9.64688 48.1165 9.59757 48.0917 9.57291C47.8443 9.42495 47.6711 9.37563 47.3742 9.27699ZM49.7494 18.9928C49.403 19.0175 49.2051 19.0175 48.8587 19.0421C48.8339 19.0421 48.7845 19.0914 48.7597 19.2147C48.735 19.3134 48.6855 19.4367 48.6608 19.5846C48.636 19.7326 48.5865 19.8805 48.5618 20.0532C48.5371 20.2258 48.5123 20.3984 48.4876 20.5217C48.2649 22.1245 48.0917 22.9136 47.6216 24.4179C47.5721 24.5658 47.5227 24.7138 47.4979 24.8617C47.4484 25.0097 47.4237 25.133 47.3742 25.2563C47.3495 25.3796 47.3247 25.4782 47.3247 25.5275C47.3247 25.6015 47.3495 25.6262 47.3742 25.6015C47.6958 25.5029 47.8443 25.4289 48.1412 25.3303C48.1659 25.3303 48.2154 25.281 48.2402 25.2316C48.2896 25.1823 48.3391 25.1083 48.3886 25.0097C48.4628 24.8864 48.5371 24.7384 48.6113 24.5905C48.6855 24.4425 48.7597 24.2699 48.8092 24.122C49.3783 22.6671 49.5762 21.878 49.8236 20.2751C49.8483 20.1025 49.8731 19.9299 49.8731 19.7819C49.8731 19.6339 49.8978 19.5106 49.8731 19.3874C49.8731 19.2641 49.8483 19.1408 49.8236 19.0914C49.8236 19.0175 49.7989 18.9928 49.7494 18.9928Z" fill="#01C3F7"/>
                      <path d="M8.7536 38.671C8.7536 38.5724 8.72886 38.4737 8.72886 38.3998C8.70412 38.3258 8.67938 38.2271 8.6299 38.1532C8.58041 38.0792 8.48145 38.0299 8.35774 37.9805C8.23404 37.9312 8.03611 37.9066 7.76395 37.9066H6.50215C6.20525 37.9066 6.00732 37.9312 5.90836 37.9559C5.80939 38.0052 5.73517 38.0792 5.6362 38.1778C5.56198 38.2765 5.53724 38.4737 5.61146 38.745C5.66094 38.9176 5.73517 39.0409 5.80939 39.1149C5.90836 39.1889 6.00732 39.2135 6.10629 39.2382C6.20525 39.2382 6.45266 39.2628 6.79904 39.2628H8.43197C8.60516 39.2628 8.87731 39.2628 9.22369 39.2875C9.57007 39.3122 9.86696 39.3615 10.0896 39.4354C10.3123 39.5341 10.5102 39.6574 10.6587 39.8793C10.8071 40.0766 10.9061 40.3478 10.9308 40.6931C10.9803 41.0383 10.9803 41.4082 10.9556 41.8274C10.9308 42.2466 10.8566 42.5425 10.7824 42.7152C10.7082 42.8878 10.6092 43.0111 10.5102 43.1097C10.4113 43.2083 10.2628 43.307 10.0402 43.381C9.84222 43.4549 9.52058 43.5043 9.12472 43.5043H5.95784C5.43827 43.5043 5.04241 43.4796 4.795 43.4056C4.54759 43.3316 4.34966 43.2577 4.25069 43.2083C4.15173 43.159 4.05276 43.0604 3.97854 42.9617C3.87957 42.8384 3.80535 42.6905 3.78061 42.4932C3.73112 42.2959 3.70638 42.074 3.70638 41.8521V41.3589H5.66094C5.66094 41.5315 5.66094 41.6548 5.68568 41.7534C5.71043 41.8521 5.75991 41.9014 5.80939 41.9507C5.85887 42 5.9331 42.0493 5.98258 42.074C6.0568 42.0987 6.13103 42.1233 6.20525 42.1233H7.86292C8.13507 42.1233 8.35774 42.1233 8.50619 42.0987C8.65464 42.074 8.77835 42.0247 8.87731 41.9014C8.97628 41.8028 9.02576 41.5808 8.97628 41.2602C8.95153 41.1123 8.90205 41.0137 8.85257 40.915C8.77835 40.8164 8.65464 40.7671 8.48145 40.7671H5.85887C5.43827 40.7671 5.14138 40.7671 4.99293 40.7671C4.84448 40.7671 4.67129 40.7177 4.4981 40.6684C4.32491 40.5944 4.17647 40.4958 4.05276 40.3478C3.92905 40.1999 3.85483 40.0273 3.78061 39.8053C3.73112 39.6081 3.68164 39.3615 3.68164 39.0902V38.1038C3.68164 37.8819 3.73112 37.66 3.80535 37.4134C3.90431 37.1668 4.05276 36.9942 4.27543 36.8462C4.4981 36.7229 4.795 36.6243 5.16612 36.575C5.53724 36.5256 5.88362 36.5256 6.20525 36.5256H8.7536C9.00102 36.5256 9.24843 36.5503 9.52058 36.575C9.79274 36.5996 9.96593 36.6736 10.0896 36.7476C10.2133 36.8216 10.337 36.9202 10.436 37.0435C10.535 37.1668 10.6092 37.2901 10.6339 37.4134C10.6834 37.5367 10.7082 37.6846 10.7082 37.8572L10.7329 38.7203H8.7536V38.671Z" fill="white"/>
                      <path d="M12.2422 36.4517H17.2647C17.7348 36.4517 18.0811 36.5256 18.3285 36.6736C18.576 36.8216 18.7491 36.9695 18.8481 37.1421C18.9471 37.3147 19.0213 37.512 19.0708 37.7093C19.1203 37.9312 19.145 38.2025 19.145 38.5231C19.145 38.8436 19.145 39.1889 19.145 39.5587C19.1203 40.0766 19.0708 40.4958 18.9718 40.7424C18.8729 41.0137 18.7491 41.2109 18.576 41.3589C18.4028 41.5068 18.2296 41.5808 18.0317 41.6301C17.8337 41.6795 17.5863 41.7041 17.2647 41.7041H14.172V43.0604L12.2422 43.5536V36.4517ZM14.172 38.1038V40.0766H16.4977C16.7946 40.0766 16.9925 40.0026 17.0915 39.8547C17.2152 39.7067 17.2647 39.4354 17.2399 39.0656C17.2152 38.745 17.1657 38.4984 17.0667 38.3504C16.9678 38.2025 16.7698 38.1285 16.4977 38.1285H14.172V38.1038Z" fill="white"/>
                      <path d="M20.457 38.819C20.457 38.5724 20.5065 38.3011 20.5807 37.9805C20.655 37.6846 20.7787 37.438 20.9024 37.2654C21.0261 37.0928 21.1993 36.9202 21.4467 36.7722C21.6941 36.6243 22.0157 36.5503 22.4611 36.5503H26.0733C26.6176 36.5503 27.0135 36.6243 27.2609 36.7969C27.5083 36.9695 27.6815 37.1421 27.8052 37.3394C27.9289 37.5367 28.0279 37.7586 28.1021 38.0299C28.1763 38.3011 28.2011 38.6463 28.2011 39.0409V40.8657C28.2011 41.2109 28.1763 41.5562 28.1268 41.926C28.0773 42.2959 28.0031 42.5672 27.8547 42.7398C27.731 42.9124 27.5825 43.0604 27.4341 43.159C27.2856 43.2577 27.1372 43.3563 26.9392 43.4303C26.7413 43.5043 26.4444 43.5536 26.0486 43.5536H22.4858C22.2631 43.5536 21.991 43.5043 21.7188 43.4056C21.4467 43.307 21.1745 43.1097 20.9271 42.8631C20.6797 42.5919 20.556 42.3206 20.556 42L20.457 40.841V38.819ZM23.5744 38.1532C23.327 38.1532 23.1538 38.1778 23.0054 38.2271C22.8569 38.2765 22.758 38.3258 22.659 38.4244C22.5848 38.523 22.5106 38.6463 22.4611 38.7943C22.4116 38.9423 22.3869 39.0902 22.3869 39.2875V40.6931C22.3869 41.0383 22.4116 41.2602 22.4611 41.4082C22.5106 41.5562 22.5848 41.6548 22.659 41.7288C22.7332 41.8028 22.8569 41.8274 22.9806 41.8521C23.1043 41.8767 23.3023 41.9014 23.5992 41.9014H25.0837C25.1826 41.9014 25.3558 41.8767 25.5785 41.8521C25.8011 41.8274 25.9249 41.7781 25.9991 41.7288C26.0733 41.6795 26.1228 41.5562 26.197 41.3835C26.2712 41.2109 26.296 40.989 26.296 40.7424V39.2875C26.296 39.0902 26.2712 38.9176 26.2218 38.7696C26.1723 38.6463 26.098 38.523 26.0238 38.4244C25.9249 38.3258 25.8011 38.2765 25.628 38.2271C25.4548 38.1778 25.2568 38.1532 25.0837 38.1532H23.5744Z" fill="white"/>
                      <path d="M29.4863 36.4517H34.583C35.1026 36.4517 35.4985 36.5256 35.7706 36.6736C36.0428 36.8216 36.2407 37.0188 36.3644 37.2901C36.4881 37.5613 36.5623 37.7833 36.6118 38.0052C36.6366 38.2025 36.6613 38.4984 36.6613 38.8683C36.6613 39.2382 36.6366 39.5341 36.6118 39.7807C36.5623 40.0026 36.5128 40.1752 36.4139 40.2985C36.3149 40.4218 36.216 40.5205 36.0675 40.6191L35.6716 40.8657C35.8201 40.9397 35.9685 41.0137 36.0675 41.063C36.1665 41.137 36.2902 41.2109 36.3891 41.3342C36.4881 41.4575 36.5623 41.5808 36.5871 41.7288C36.6118 41.8767 36.6366 42 36.6366 42.1233V43.1344L34.6325 43.6029V42.7152C34.6325 42.5179 34.6078 42.3453 34.5335 42.222C34.4841 42.0987 34.3851 41.9754 34.2614 41.8767C34.1377 41.7781 33.9892 41.7288 33.8161 41.7288H31.4161V43.1837L29.5358 43.6029V36.4517H29.4863ZM31.3667 38.0792V40.0519H33.6429C33.9398 40.0519 34.1377 40.0273 34.2367 39.978C34.3356 39.9286 34.4098 39.8547 34.4841 39.7807C34.5335 39.682 34.583 39.5094 34.583 39.2135C34.583 38.9176 34.5583 38.6957 34.4593 38.5231C34.3851 38.3998 34.2861 38.3011 34.1624 38.2025C34.0387 38.1285 33.8408 38.0792 33.6181 38.0792H31.3667Z" fill="white"/>
                      <path d="M44.8761 36.4763L44.2823 38.1038H42.303V43.1097L40.398 43.6276V38.1038H37.9238V36.4763H44.8761Z" fill="white"/>
                      <path d="M51.1104 38.671C51.1104 38.5724 51.0856 38.4737 51.0856 38.3998C51.0609 38.3258 51.0362 38.2271 50.9867 38.1532C50.9372 38.0792 50.8382 38.0299 50.7145 37.9805C50.5908 37.9312 50.3929 37.9066 50.1207 37.9066H48.8589C48.562 37.9066 48.3641 37.9312 48.2651 37.9559C48.1662 38.0052 48.0919 38.0792 47.993 38.1778C47.9188 38.2765 47.894 38.4737 47.9682 38.745C48.0177 38.9176 48.0919 39.0409 48.1662 39.1149C48.2651 39.1889 48.3641 39.2135 48.4631 39.2382C48.562 39.2382 48.8094 39.2628 49.1558 39.2628H50.7887C50.9619 39.2628 51.2341 39.2628 51.5805 39.2875C51.9268 39.3122 52.2237 39.3615 52.4464 39.4354C52.6691 39.5341 52.867 39.6574 53.0155 39.8793C53.1639 40.0766 53.2629 40.3478 53.2876 40.6931C53.3371 41.0383 53.3371 41.4082 53.3124 41.8274C53.2876 42.2466 53.2134 42.5425 53.1392 42.7152C53.0649 42.8878 52.966 43.0111 52.867 43.1097C52.768 43.2083 52.6196 43.307 52.3969 43.381C52.199 43.4549 51.8774 43.5043 51.4815 43.5043H48.3146C47.795 43.5043 47.3992 43.4796 47.1518 43.4056C46.9044 43.3316 46.7064 43.2577 46.6075 43.2083C46.5085 43.159 46.4095 43.0604 46.3353 42.9617C46.2363 42.8384 46.1621 42.6905 46.1374 42.4932C46.0879 42.2959 46.0632 42.074 46.0632 41.8521V41.3589H48.0177C48.0177 41.5315 48.0177 41.6548 48.0425 41.7534C48.0672 41.8521 48.1167 41.9014 48.1662 41.9507C48.2156 42 48.2899 42.0493 48.3394 42.074C48.4136 42.0987 48.4878 42.1233 48.562 42.1233H50.2197C50.4918 42.1233 50.7145 42.1233 50.863 42.0987C51.0114 42.074 51.1351 42.0247 51.2341 41.9014C51.3331 41.8028 51.3825 41.5808 51.333 41.2602C51.3083 41.1123 51.2588 41.0137 51.2093 40.915C51.1351 40.8164 51.0114 40.7671 50.8382 40.7671H48.1909C47.7703 40.7671 47.4734 40.7671 47.325 40.7671C47.1765 40.7671 47.0033 40.7177 46.8301 40.6684C46.6569 40.5944 46.5085 40.4958 46.3848 40.3478C46.2611 40.1999 46.1869 40.0273 46.1126 39.8053C46.0632 39.6081 46.0137 39.3615 46.0137 39.0902V38.1038C46.0137 37.8819 46.0632 37.66 46.1374 37.4134C46.2363 37.1668 46.3848 36.9942 46.6075 36.8462C46.8301 36.7229 47.127 36.6243 47.4981 36.575C47.8693 36.5256 48.2156 36.5256 48.5373 36.5256H51.0856C51.333 36.5256 51.5805 36.5503 51.8526 36.575C52.1 36.6243 52.298 36.6736 52.4217 36.7476C52.5454 36.8216 52.6691 36.9202 52.768 37.0435C52.867 37.1668 52.9412 37.2901 52.966 37.4134C53.0155 37.5367 53.0402 37.6846 53.0402 37.8572L53.0649 38.7203H51.1104V38.671Z" fill="white"/>
                      <path d="M55.3158 37.9312H54.5488V36.501H56.8993V43.0357L55.3158 43.6029V37.9312Z" fill="#01C3F7"/>
                      <path d="M60.9573 38.3998C60.9573 38.3504 60.9325 38.2765 60.9325 38.1778C60.9325 38.0792 60.9078 38.4737 60.883 38.3998C60.8583 38.3011 60.8088 38.2025 60.7593 38.1038C60.6851 38.0052 60.5861 37.9312 60.4624 37.9312H59.8439C59.6212 37.9312 59.4728 38.0052 59.3986 38.1285C59.2996 38.2518 59.2501 38.3998 59.2501 38.5231C59.2501 38.671 59.2254 38.7943 59.2254 38.9423C59.2254 39.0162 59.2254 39.0902 59.2254 39.1395C59.2254 39.1889 59.2501 39.2382 59.2501 39.2628C59.2748 39.2875 59.2996 39.3122 59.2996 39.3122C59.3243 39.3122 59.3491 39.2875 59.3986 39.2628C59.448 39.2135 59.5223 39.1889 59.646 39.1889C59.7697 39.1642 59.8934 39.1642 60.0171 39.1642H60.982C61.1552 39.1642 61.2789 39.1642 61.4026 39.1889C61.5016 39.2135 61.6253 39.2382 61.7242 39.2875C61.8232 39.3368 61.9222 39.3861 61.9964 39.4354C62.0706 39.4848 62.1448 39.5587 62.1943 39.6327C62.2438 39.7067 62.318 39.8053 62.3675 39.9533C62.417 40.1013 62.4665 40.2245 62.4912 40.3478C62.516 40.4711 62.5407 40.6191 62.5654 40.841C62.5902 41.0383 62.5902 41.2849 62.5654 41.5562C62.5654 41.7041 62.5407 41.8521 62.516 41.9754C62.4912 42.0987 62.4912 42.222 62.4665 42.3206C62.4417 42.4192 62.417 42.5425 62.3428 42.6658C62.2933 42.7891 62.2191 42.9124 62.1448 43.0111C62.0706 43.1097 61.9964 43.1837 61.9222 43.233C61.8479 43.2823 61.749 43.3316 61.65 43.381C61.551 43.4303 61.4273 43.4549 61.3284 43.4796C61.2047 43.5043 61.0562 43.5043 60.883 43.5043C60.5861 43.5043 60.2645 43.5043 59.8934 43.5043C59.5223 43.5043 59.2748 43.4796 59.1017 43.4796C58.9532 43.4796 58.8048 43.4303 58.7058 43.4056C58.6068 43.3563 58.5079 43.307 58.4089 43.233C58.3099 43.159 58.2357 43.1097 58.211 43.0604C58.1615 43.0111 58.112 42.9371 58.0378 42.8138C57.9636 42.7152 57.9141 42.5672 57.8893 42.4192C57.8398 42.2713 57.8151 42.0987 57.7904 41.9261C57.7656 41.7534 57.7656 41.5315 57.7656 41.2849V38.4491C57.7656 38.3998 57.7904 38.2765 57.8151 38.0545C57.8398 37.8326 57.8646 37.66 57.9141 37.5613C57.9388 37.438 57.9883 37.3394 58.0378 37.2161C58.0873 37.1175 58.1615 37.0188 58.211 36.9448C58.2605 36.8709 58.3594 36.7969 58.5079 36.6983C58.6316 36.5996 58.78 36.5503 58.9285 36.5256C59.0769 36.501 59.2501 36.4763 59.448 36.4763H61.0562C61.2542 36.4763 61.4026 36.4763 61.5016 36.501C61.6005 36.5256 61.7242 36.575 61.8479 36.6489C61.9716 36.7229 62.0706 36.7969 62.1448 36.8955C62.2191 36.9942 62.2933 37.0928 62.3675 37.2161C62.4417 37.3394 62.4912 37.4874 62.516 37.6353C62.5654 37.7833 62.5654 37.9559 62.5902 38.1285C62.5902 38.3011 62.6149 38.0052 62.5902 38.2025V38.3998H60.9573ZM59.8439 40.6191C59.6707 40.6438 59.547 40.6684 59.448 40.7177C59.3491 40.7671 59.2748 40.8164 59.2501 40.8904C59.2254 40.9643 59.2006 41.1123 59.2254 41.3589C59.2254 41.5808 59.2501 41.7534 59.2748 41.8274C59.2996 41.9014 59.3738 41.9507 59.4728 42C59.5717 42.0493 59.6707 42.0493 59.8192 42.0493C59.8686 42.0493 59.9923 42.0493 60.1903 42.0493C60.3882 42.0493 60.5367 42.0247 60.6356 41.9754C60.7346 41.9261 60.8088 41.8767 60.8335 41.7781C60.883 41.7041 60.883 41.5562 60.883 41.3589C60.883 41.1616 60.883 41.0137 60.8583 40.9397C60.8088 40.7917 60.7593 40.7177 60.7098 40.6931L60.2892 40.5944H59.8439V40.6191Z" fill="#01C3F7"/>
                      <path d="M66.5497 43.5043H64.5209C64.2488 43.5043 64.0756 43.5043 63.9766 43.4796C63.9024 43.4549 63.7787 43.4056 63.655 43.3563C63.5313 43.2823 63.4076 43.1837 63.3334 43.085C63.2344 42.9617 63.1849 42.8384 63.1354 42.6905C63.0859 42.5425 63.0612 42.3699 63.0117 42.1233C62.9622 41.9014 62.9622 41.5315 63.0117 41.0137C63.0365 40.7424 63.0612 40.5451 63.1107 40.4218C63.1602 40.2985 63.2097 40.1999 63.2839 40.0766C63.3581 39.978 63.4076 39.904 63.4076 39.8793C63.4076 39.8547 63.3828 39.8053 63.3334 39.7314C63.2839 39.6574 63.2591 39.5587 63.2097 39.4354C63.1602 39.3122 63.1354 39.2135 63.1107 39.1395C63.0859 39.0656 63.0612 38.9176 63.0612 38.6957C63.0365 38.4737 63.0365 38.2765 63.0612 38.1038C63.0612 38.0299 63.0612 37.9312 63.0859 37.8326C63.0859 37.7339 63.1107 37.6107 63.1354 37.4874C63.1602 37.3641 63.2097 37.2161 63.3086 37.0928C63.3828 36.9448 63.4818 36.8462 63.5808 36.7722C63.6797 36.6983 63.754 36.6489 63.8282 36.6243C63.9024 36.5996 63.9766 36.575 64.0756 36.5503C64.1746 36.5256 64.2488 36.5256 64.323 36.5256H66.2528C66.4755 36.5256 66.6239 36.5256 66.6982 36.5503C66.7724 36.575 66.8466 36.5996 66.9456 36.6489C67.0445 36.6983 67.1188 36.7476 67.1683 36.7969C67.2425 36.8462 67.292 36.9202 67.3662 37.0435C67.4404 37.1421 67.4899 37.2901 67.5394 37.4874C67.5889 37.6846 67.6383 37.8819 67.6383 38.1038C67.6383 38.3258 67.6383 38.5231 67.6383 38.671C67.6383 38.819 67.6136 38.9916 67.5889 39.1395C67.5641 39.2875 67.5146 39.4601 67.4157 39.5834C67.3415 39.7314 67.292 39.8053 67.2672 39.83C67.2672 39.8547 67.2672 39.8793 67.2672 39.904C67.2672 39.9286 67.292 39.978 67.3662 40.0766C67.4404 40.1752 67.4899 40.2739 67.5394 40.3725C67.5889 40.4711 67.6136 40.5698 67.6383 40.6438C67.6631 40.7177 67.6631 40.9397 67.6878 41.2849C67.6878 41.6301 67.7126 41.8767 67.6878 42C67.6631 42.148 67.6383 42.3206 67.6136 42.4686C67.5889 42.6165 67.5394 42.7645 67.4899 42.8384C67.4404 42.9371 67.3662 43.0357 67.2425 43.1837C67.1188 43.307 66.9951 43.4056 66.8961 43.4549C66.8219 43.4796 66.6982 43.5043 66.5497 43.5043ZM65.7827 39.1642C65.857 39.1395 65.9064 39.1395 65.9559 39.1149C66.0054 39.0902 66.0549 39.0409 66.0796 38.9916C66.1291 38.9176 66.1539 38.7696 66.1539 38.4984C66.1539 38.2271 66.1291 38.0545 66.0302 37.9805C65.9559 37.8819 65.8322 37.8326 65.6838 37.8326H64.9663C64.7931 37.8326 64.6446 37.8819 64.5704 38.0052C64.4962 38.1038 64.4467 38.2765 64.4715 38.523C64.4715 38.671 64.4962 38.7696 64.4962 38.8683C64.5209 38.9423 64.5457 39.0162 64.5952 39.0902C64.6446 39.1642 64.7436 39.1889 64.8921 39.1889H65.7827V39.1642ZM65.7085 40.5698H65.1395C64.9663 40.5698 64.8673 40.5944 64.7931 40.6191C64.7189 40.6438 64.6694 40.6931 64.6199 40.7671C64.5704 40.841 64.5457 40.915 64.5209 41.0137C64.5209 41.0876 64.4962 41.2602 64.4962 41.5068C64.4962 41.7534 64.5209 41.926 64.6199 42.0247C64.7189 42.1233 64.8426 42.1726 65.0405 42.1726H65.5848C65.7333 42.1726 65.8322 42.148 65.9312 42.1233C66.0302 42.0987 66.0796 42.074 66.1044 42.0247C66.1291 41.9754 66.1539 41.9261 66.1786 41.8521C66.2034 41.7781 66.2033 41.7041 66.2033 41.5808V41.4082C66.2281 41.0383 66.1786 40.8164 66.0796 40.7177C66.0302 40.6191 65.8817 40.5698 65.7085 40.5698Z" fill="#01C3F7"/>
              </svg>  -->
      </div>
      <div class="nav-header__title flex-col">
        <template v-if="$route.name === 'oddsResultFilter'">
          <span class="bold">{{ $t("FILTER_ODDS_COMPARISON") }}</span>
        </template>
        <template v-else>
          <span class="bold">{{ $t(mobileHeaderTitle) }}</span>
          <span class="font-s">{{ $t(mobileSubHeaderTitle) }}</span>
        </template>
      </div>
  
      <!-- <NewsLanguageOption /> -->
      <!-- <div id="news-language-selection-portal" class="nav-header__right news_header-right" v-if="['news','competitionNews','latestNews'].includes($route.name)"></div> -->
  
      <div
        class="nav-header__more"
        v-if="!isOddsMore"
        v-show="isShowMoreButton"
        @click="handleMore()"
      ></div>
      <div v-if="!isOddsMore" class="nav-header__right nav-header__share">
        <div
          class="display-flex-center mlr-05rem 1"
          v-show="isShowMatchDetailButton"
        >
        <MatchDetailIcon
            @toMatchDetailPage="$emit('toMatchDetailPage')"
          ></MatchDetailIcon>
        </div>
        <div
          class="display-flex-center mlr-05rem 2"
          v-show="isShowNotiPreferenceCog"
          @click="$emit('toggleSettingEvent')"
        >
          <Cog></Cog>
        </div>
        <!-- <div
          class="display-flex-center mlr-05rem 3"
          v-show="isShowHighlightButton"
          @click="$emit('handleHighlight')"
        >
          <img
            src="../../../static/images/icons/icon_highlight_mobile_header.png"
          />
        </div> -->
        <!-- <div
          class="display-flex-center mlr-05rem 4"
          @click="$emit('toggleLiveStream')"
          v-show="matchState > 0 || (containLiveStream && matchState == -1) || (containLiveStream && !isMatchEndedOrCancelled)"
        >
          <img src="../../../static/images/icons/icon_live_video.gif" width="24" height="24" v-show="containLiveStream" />
          <img src="../../../static/images/icons/icon_live_video_disabled.png" v-show="!containLiveStream" />
        </div> -->
        <div
          class="display-flex-center mlr-05rem 5"
          v-if="isShowHighlightButton"
          @click="toggleHightlights()"
        >
          <IconMode>
            <template #default="{ index }">
                <img src="@static/images/icons/aspn_icon/highlights/icon_highlights_selected.png" 
                  v-if="['lightWebapp'].includes(index) && displayHighlights" />
                <img src="@static/images/icons/aspn_icon/highlights/icon_highlights.png" 
                  v-else-if="['lightWebapp'].includes(index)" />
                <img src="@static/images/icons/aspn_icon/highlights/icon_highlights_dark_selected.png" 
                    v-else-if="['darkWebapp'].includes(index) && displayHighlights" />
                <img src="@static/images/icons/aspn_icon/highlights/icon_highlights_dark.png" 
                  v-else-if="['darkWebapp'].includes(index)" />
            </template>
          </IconMode> 
          <!-- <img
            src="../../../static/images/icons/aspn_icon/icon_live_selected.png"
            width="24"
            height="24"
            v-show="containLiveStream"
          /> -->
          <!-- 18/11/2024 - current case without live stream, can revert when it is needed -->
          <!-- <img
            src="../../../static/images/icons/aspn_icon/icon_live.png"
            v-show="!containLiveStream"
          /> -->
        </div>
        <!-- <div
          class="display-flex-center mlr-05rem 6"
          @click="toggleTracker"
          v-show="
            matchState > 0 ||
            (containTracker && matchState == -1) ||
            (containTracker && !isMatchEndedOrCancelled)
          "
        >
          <img
            src="../../../static/images/icons/icon_match_tracker.png"
            v-show="containTracker && !isTrackerSelected"
          />
          <img
            src="../../../static/images/icons/icon_match_tracker_selected.png"
            v-show="containTracker && isTrackerSelected"
          />
          <img
            src="../../../static/images/icons/icon_match_tracker_disabled.png"
            v-show="!containTracker"
          />
        </div> -->
  
        <div
          class="display-flex-center mlr-05rem 7"
          v-show="isShowSocialMediaShareButton && isMobile"
          @click="handleMore()"
        >
        <IconMode>
          <template #default="{ index }">
            <img src="@static/images/icons/aspn_icon/social_media/icon_share.png" v-if="['lightWeb','lightWebapp'].includes(index)" />
            <img src="@static/images/icons/aspn_icon/social_media/icon_share_dark.png" v-else-if="['darkWeb','darkWebapp'].includes(index)" />
          </template>
        </IconMode> 
        </div>
  
        <slot name="datepicker" />
        <div v-show="scrollTop < 45.59">
          <Pill
            v-if="mobileFilterPill !== null && mobileFilterPill.show"
            :filterProp="mobileFilterPill"
            @isReady="$emit('filterPillIsReady')"
          />
        </div>
  
        <slot name="fav">
          <div class="btn-fav-wrapper-mobile mlr-05rem" v-show="isShowFavButton">
            <FavStarButton
              class="normal header-fav-icon"
              :isFav="isFav"
              :favDisabled="favDisabled"
              @toggleFavThis="$emit('toggleFavThis')"
            ></FavStarButton>
          </div>
        </slot>
  
        <div
          class="display-flex-center nav-header__right-search__wrapper"
          v-show="
            tabs === 'footballFavTeams' ||
            tabs === 'footballFavCompetitions' ||
            tabs === 'footballFavPlayers' ||
            tabs === 'basketballFavTeams' ||
            tabs === 'basketballFavCompetitions' ||
            tabs === 'basketballFavPlayers'
          "
          @click="handleMobileSearch"
        >
          <IconMode>
            <template #default="{ index }">
              <img src="@static/images/icons/aspn_icon/icon_search_webapp.png" v-if="['lightWeb','lightWebapp'].includes(index)" class="search-icon-webapp" />
              <img src="@static/images/icons/aspn_icon/icon_search_webapp_dark.png" v-else-if="['darkWeb','darkWebapp'].includes(index)" class="search-icon-webapp" />
            </template>
          </IconMode> 
        </div>
        
        <FavModal @closeModal="toggleModal" :tabName="favIsTab[tabs]" />
  
        <!-- <div
          class="display-flex-center ml-05rem mr-1rem"
          v-show="isShowRefreshButton"
          @click="triggerManualRefresh"
        > -->
        <!-- @click="$emit('handleRefresh')" -->
        <!-- <img
            src="../../../static/images/icons/icon_refresh.png"
            :class="{ 'refresh-button': !manualRefreshStopButtonSpin }"
          /> -->
        <!-- :class="{'refresh-button': manualRefreshMatchDetail} -->
        <!-- </div> -->
      </div>
  
      <div
        v-if="isOddsMore"
        class="nav-header__right nav-header__share"
        @click="handleMenu()"
      >
        <img src="../../../static/images/icons/icon_filter_float.png" />
      </div>
  
      <!-- <div class="nav-header__fav"></div> -->
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import MainLogo from "@/components/indicator/MainLogo.vue";
import FavStarButton from "@/components/ui/FavStarButton.vue";
import MatchDetailIcon from "@/components/ui/MatchDetailIcon.vue";
import Cog from "@/components/ui/Cog.vue";
import Pill from "@/components/ui/Pill.vue";
import FavModal from '../../views/fav/components/Modal.vue'
import NewsLanguageOption from '@/components/news/NewsLanguage.vue'
export default {
  components: {
    MainLogo,
    FavStarButton,
    MatchDetailIcon,
    Cog,
    Pill,
    FavModal,
    NewsLanguageOption
  },
  props: {
    mobileHeaderTitle: {
      type: String,
      default: "",
    },
    mobileSubHeaderTitle: {
      type: String,
      default: "",
    },
    isShowBackButton: {
      type: Boolean,
      default: true,
    },
    isShowMoreButton: {
      type: Boolean,
      default: false,
    },
    isShowSocialMediaShareButton: {
      type: Boolean,
      default: false,
    },
    isShowMatchDetailButton: {
      type: Boolean,
      default: false,
    },
    isShowHighlightButton: {
      type: Boolean,
      default: false,
    },
    isShowNotiPreferenceCog: {
      type: Boolean,
      default: false,
    },
    matchState: {
      type: Number,
      default: null,
    },
    isMatchEndedOrCancelled: {
      type: Boolean,
      default: false,
    },
    containLiveStream: {
      type: Boolean,
      default: false,
    },
    containTracker: {
      type: Boolean,
      default: false,
    },
    isShowFavButton: {
      type: Boolean,
      default: false,
    },
    isShowRefreshButton: {
      type: Boolean,
      default: false,
    },
    isFav: {
      type: Boolean,
      default: false,
    },
    favDisabled: {
      type: Boolean,
      default: false,
    },
    tabs: {
      type: String,
      default: "",
    },
    isTrackerSelected: {
      type: Boolean,
      default: false,
    },
    mobileFilterPill: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      manualRefreshStopButtonSpin: true,
      favIsTab: {
        footballFavTeams: 'TEAMS',
        footballFavCompetitions: 'COMPETITIONS',
        footballFavPlayers: 'PLAYERS'
      },
      displayHighlights: false,
    };
  },
  watch: {
    "$route.name": {
      handler(newVal) {
        if (
          (newVal === "oddsResult" || newVal === "oddsResultFilter") &&
          !this.isOddsMore
        ) {
          this.isOddsMoreToggle(true);
        }
        if (newVal === "oddsResultFilter") {
          this.isOddsMenuToggle(true);
        } else this.isOddsMenuToggle(false);
      },
      immediate: true,
    },
    manualRefreshMatchDetailScore: {
      handler(newVal, oldVal) {
        this.controlManualRefreshButtonCycle(newVal);
      },
    },
    manualRefreshMatchDetail: {
      handler(newVal, oldVal) {
        this.controlManualRefreshButtonCycle(newVal);
      },
    },
  },
  computed: {
    ...mapState(["scrollTop"]),
    ...mapGetters([
      "isRedirect",
      "currentLocale",
      "isOddsMore",
      "isOddsMenu",
      "manualRefreshMatchDetailScore",
      "manualRefreshMatchDetail",
      "isMobile"
    ]),
  },
  methods: {
    ...mapMutations([
      "MANUAL_REFRESH_MATCH_DETAIL_SCORE",
      "MANUAL_REFRESH_MATCH_DETAIL",
    ]),
    ...mapActions(["isOddsMenuToggle", "isOddsMoreToggle", "toggleFavModal"]),
    goBack() {
      this.$router.push({ path: `/${this.currentLocale}` });
      // history.go(-1)
    },
    handleMore() {
      this.$emit("moreEvent");
    },
    handleMenu() {
      this.isOddsMenuToggle();

      if (this.$route.name === "oddsResult") {
        this.$router.push({ path: `${this.$route.fullPath}/filter` });
      } else this.$router.go(-1);
    },
    toggleHightlights() {
      this.displayHighlights = !this.displayHighlights
      this.$emit('toggleHightlights', this.displayHighlights)
    },
    toggleTracker() {
      this.$emit("toggleTracker");
    },
    handleMobileSearch() {
      this.toggleModal();
    },
    toggleModal() {
      this.toggleFavModal();
      // !this.isShowFavModal && this.getFavLeagueListData();
    },
    triggerManualRefresh() {
      this.MANUAL_REFRESH_MATCH_DETAIL_SCORE();
      this.MANUAL_REFRESH_MATCH_DETAIL();
    },
    controlManualRefreshButtonCycle(bool) {
      if (bool) {
        this.manualRefreshStopButtonSpin = false;
      } else {
        setTimeout(() => {
          if (
            !this.manualRefreshMatchDetailScore &&
            !this.manualRefreshMatchDetail
          ) {
            this.manualRefreshStopButtonSpin = true;
          }
        }, 700);
      }
    },
  },
};
</script>

<style scoped>
.mobile-logo {
  width: 5rem;
  /* height: 2.25rem; */
  display: inherit;
  /* margin-top: 0.8rem; */
}
/*detail header*/
.nav-header {
  display: none;
  color: white;
  justify-content: center;
  align-items: center;
  /* padding: 1rem; */
  height: 48px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: var(--color-background-default-secondary);
  z-index: 5;
}
.nav-header img {
  width: 40px;
}
.nav-header .main-logo {
  width: unset !important;
}
.nav-header__back {
  justify-content: center;
  align-items: center;
  position: absolute;
  min-width: 2.5rem;
  padding-left: 1rem;
  height: 100%;
  display: flex;
  /* background: url('../../../static/images/icons/icon_arrow_left.png') center/contain no-repeat; */
  background-size: inherit;
}
.nav-header__title {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav-header__fav {
  position: absolute;
  top: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 2rem;
  height: 100%;
  display: flex;
  background: url("../../../static/images/icons/icon_fav_selected.png")
    center/contain no-repeat;
  background-size: inherit;
}
.nav-header__more {
  position: absolute;
  top: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 2rem;
  height: 100%;
  display: flex;
  background: url("../../../static/images/three_dot.png") center/contain
    no-repeat;
  background-size: inherit;
}
.nav-header__right {
  position: absolute;
  top: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  position: absolute;
  /* width: 3rem; */
  height: 100%;
  display: flex;
  background-size: inherit;
}
.nav-header__right-search__wrapper {
  margin-right: 0.8rem;
}
.refresh-button {
  -webkit-animation: 0.8s spin linear infinite;
  animation: 0.8s spin linear infinite;
}
.news_header-right {
  position: relative;
  top: 0;
}
.news-language__selection-wrapper {
  width: 100%;
  align-items: center !important;
  padding: 0 8px;
  height: 45.59px;
}
.header-fav-icon {
  width: 40px;
  height: 40px;
}
.search-icon-webapp {
  width: 40px;
  height: 40px;
}
@media(max-width: 768px) { /* for test */
  .nav-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 8px;
    z-index: 9;
  }
  .news-language__selection-wrapper {
  }
  #news-language-selection-portal {
    /* padding-right: 1rem; */
    background-color: var(--color-background-default-secondary);
    width: 100%;
  }
}
</style>
